document.addEventListener('click', (event) => {
    const row = event.target.closest('tr[data-href]');

    if (!row || event.target.closest('a, button, form, details, input, label, select, textarea, .account-share')) {
        return;
    }

    if (window.getSelection()?.toString()) {
        return;
    }

    if (event.metaKey || event.ctrlKey || row.dataset.hrefTarget === '_blank') {
        window.open(row.dataset.href, '_blank', 'noopener');
        return;
    }

    window.location.assign(row.dataset.href);
});
